import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { Menu, X, Phone } from "lucide-react";
import { Wordmark } from "./Logo";
import { scrollToSection, WA_LINK, WA_NUMBER } from "@/lib/api";

const LINKS = [
  { label: "Beranda", hash: "#beranda" },
  { label: "Keunggulan", hash: "#keunggulan" },
  { label: "Cara Kerja", hash: "#cara-kerja" },
  { label: "Template Excel", hash: "#template" },
  { label: "Kontak", hash: "#kontak" },
];

export const Navbar = () => {
  const [scrolled, setScrolled] = useState(false);
  const [open, setOpen] = useState(false);

  useEffect(() => {
    const onScroll = () => setScrolled(window.scrollY > 24);
    window.addEventListener("scroll", onScroll, { passive: true });
    return () => window.removeEventListener("scroll", onScroll);
  }, []);

  return (
    <header
      data-testid="main-navbar"
      className={`fixed top-0 left-0 right-0 z-50 transition-colors duration-300 border-b ${
        scrolled ? "bg-slate-950/85 backdrop-blur-xl border-white/10" : "bg-transparent border-transparent"
      }`}
    >
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 h-[72px] flex items-center justify-between">
        <button onClick={() => scrollToSection("#beranda")} className="shrink-0" data-testid="nav-logo-button">
          <Wordmark />
        </button>

        <nav className="hidden lg:flex items-center gap-7" data-testid="nav-links">
          {LINKS.map((l) => (
            <button
              key={l.hash}
              onClick={() => scrollToSection(l.hash)}
              data-testid={`nav-link-${l.hash.slice(1)}`}
              className="text-sm text-slate-300 hover:text-white transition-colors duration-200"
            >
              {l.label}
            </button>
          ))}
        </nav>

        <div className="hidden lg:flex items-center gap-3">
          <span className="flex items-center gap-2 text-xs font-mono2 text-slate-400" data-testid="nav-admin-number">
            <Phone size={13} className="text-emerald-400" /> {WA_NUMBER}
          </span>
          <a
            href={WA_LINK}
            target="_blank"
            rel="noopener noreferrer"
            data-testid="nav-whatsapp-button"
            className="text-sm font-semibold px-4 py-2 rounded-full text-white bg-gradient-to-br from-sky-600 to-sky-800 hover:from-sky-500 hover:to-sky-700 transition-colors duration-200"
          >
            WhatsApp Admin
          </a>
          <Link
            to="/admin/login"
            data-testid="admin-portal-login-button"
            className="text-sm font-medium px-4 py-2 rounded-full border border-white/15 text-slate-300 hover:text-white hover:border-sky-400/50 transition-colors duration-200"
          >
            Portal Admin
          </Link>
        </div>

        <button
          className="lg:hidden text-slate-200 p-2"
          onClick={() => setOpen(!open)}
          data-testid="nav-mobile-toggle"
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="lg:hidden glass border-t border-white/10 px-6 py-4 flex flex-col gap-3" data-testid="nav-mobile-menu">
          {LINKS.map((l) => (
            <button
              key={l.hash}
              onClick={() => {
                setOpen(false);
                scrollToSection(l.hash);
              }}
              data-testid={`nav-mobile-link-${l.hash.slice(1)}`}
              className="text-left text-sm text-slate-200 py-1.5"
            >
              {l.label}
            </button>
          ))}
          <div className="flex gap-3 pt-2">
            <a
              href={WA_LINK}
              target="_blank"
              rel="noopener noreferrer"
              data-testid="nav-mobile-whatsapp-button"
              className="flex-1 text-center text-sm font-semibold px-4 py-2.5 rounded-full text-white bg-gradient-to-br from-sky-600 to-sky-800"
            >
              WhatsApp Admin
            </a>
            <Link
              to="/admin/login"
              data-testid="nav-mobile-admin-button"
              className="flex-1 text-center text-sm font-medium px-4 py-2.5 rounded-full border border-white/15 text-slate-200"
            >
              Portal Admin
            </Link>
          </div>
        </div>
      )}
    </header>
  );
};
